var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/education/solid/pen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combo shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5303 2.46966C21.8232 2.76254 21.8232 3.23741 21.5303 3.53032L19.9112 5.14952C20.3943 6.08195 20.2448 7.2572 19.4627 8.03936L18.6688 8.83326L15.1669 5.33144L15.9608 4.53755C16.7429 3.75544 17.9181 3.6059 18.8505 4.08891L20.4696 2.46968C20.7625 2.17678 21.2374 2.17677 21.5303 2.46966ZM17.6081 9.89392L14.1063 6.39209L5.62325 14.875L9.1251 18.3768L17.6081 9.89392ZM8.04262 19.4157L4.5844 15.9575C4.1896 16.4597 3.90894 17.0445 3.76493 17.6712L3.17885 20.222C3.09619 20.5817 3.4184 20.9039 3.77812 20.8212L6.32886 20.2351C6.95558 20.0911 7.5404 19.8105 8.04262 19.4157ZM19.2242 9.38851L18.6699 8.83423L17.6092 9.89491L18.1635 10.4492L18.1635 10.4492C18.7198 11.0054 18.7198 11.9073 18.1635 12.4636L16.626 14.0011C16.3331 14.294 16.3331 14.7689 16.626 15.0618C16.9189 15.3546 17.3938 15.3546 17.6867 15.0618L19.2242 13.5242C20.3662 12.3822 20.3662 10.5306 19.2242 9.38851Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.5757bac60322a8bffc8287881a1c4a3a.svg";
export { ForwardRef as ReactComponent };